import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import config from '@/config.json';
import { axios } from '@/services/axios';
import {
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
} from '@chakra-ui/react';
import walkthroughIds from './walkthroughIds';
import { useQuery } from 'hooks/useCustomQuery';

import {
    customTabStylesCombineTheme,
    selectedTabStylesCombineTheme,
} from '@/constants';
import APIUsers from './apiUsers/index';
import Permissions from '../permissions/Index';
import AdminAccounts from './adminUsers/Index';

// Component for Table of the 'Admins' Page in the sidebar
const Admins = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { state } = location;

    const [tabIndex, setTabIndex] = useState(
        state?.index != null ? state.index : 0,
    );

    const { darkMode } = useSelector((state) => state.settings);
    const { currentCompany } = useSelector((state) => state.navigationLists);

    // Set global flag for Permissions tab to unlock scope dropdown in Navbar
    useEffect(() => {
        window.__adminsPermissionsTabActive = tabIndex === 2;
        return () => {
            window.__adminsPermissionsTabActive = false;
        };
    }, [tabIndex]);

    useQuery({
        queryKey: ['currentAdminUser'],
        queryFn: async () => {
            const response = await axios.get('/adminuser/me');
            return response.data;
        },
        enabled: state?.index == null,
        onSuccess: (data) => {
            dispatch({
                type: 'SET_IS_CURRENT_USER_MFA_ENABLED',
                payload: data.mfaEnabled,
            });
        },
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (state?.index != null) {
            setTabIndex(state.index);
        }
    }, [state]);

    const getTitle = (tabIndex) => {
        switch (tabIndex) {
            case 1:
                return config.apiUsers.tableTitle;
            case 2:
                return config.permissions.tableTitle;
            default:
                return config.adminUsers.tableTitle;
        }
    };

    return (
        <>
            {currentCompany && (
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>
                    {getTitle(tabIndex)}
                </Text>
            )}

            {currentCompany && (
                <Tabs
                    index={tabIndex}
                    isLazy
                    onChange={(index) => {
                        dispatch({
                            type: 'RESET_MODAL',
                        });
                        dispatch({
                            type: 'RESET_TABLE',
                        });
                        setTabIndex(index);
                    }}>
                    <TabList borderBottom="none" mb={2}>
                        {config.adminUsers.tabsList.map((tab, index) => (
                            <Tab
                                data-walkthroughid={
                                    walkthroughIds.ufTabButton + tab
                                }
                                key={index}
                                onMouseDown={(e) =>
                                    e.button === 2 && e.preventDefault()
                                }
                                sx={{
                                    ...customTabStylesCombineTheme,
                                    color: darkMode
                                        ? 'rgba(255, 255, 255)'
                                        : '#262626',
                                }}
                                _selected={{
                                    ...selectedTabStylesCombineTheme,
                                }}>
                                {tab}
                            </Tab>
                        ))}
                    </TabList>
                    <TabPanels>
                        <TabPanel padding={0}>
                            {tabIndex == 0 && <AdminAccounts />}
                        </TabPanel>
                        <TabPanel padding={0}>
                            {tabIndex == 1 && <APIUsers />}
                        </TabPanel>
                        <TabPanel padding={0}>
                            {tabIndex == 2 && <Permissions />}
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            )}
            {!currentCompany && <AdminAccounts />}
        </>
    );
};

export default Admins;
